/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @deprecated Since 2026-10-23. Use `InfCPaginationPipe` (pipe `infcPagination`) from
 * `@infodata-group/inf-commons-core`.
 */
@Pipe({
  name: 'pagination',
  standalone: true,
})
export class PaginationPipe<T> implements PipeTransform {
  transform(value: T[], index: number, step: number, fullLoad: boolean): T[] {
    const array = [];
    const position = fullLoad ? index * step : 0;
    for (let i = 0; value && position + i < value.length && i < step; ++i) {
      array.push(value[position + i]);
    }
    return array;
  }
}
